import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { Title } from "@angular/platform-browser";

import { ApiService, } from "src/app/api.service";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { FleetTrackerService } from "src/app/fleet-tracker.service";
import { DvsUtilities } from "src/app/dvs-utilities";
declare const BrandVars;

@Component({
	selector: "app-asset",
	templateUrl: "./asset.component.html",
	styleUrls: ["./asset.component.scss"]
})
export class AssetComponent implements OnInit, OnDestroy {
	private subscriptions: Subscription[] = [];
	fleet?: APIResults.Fleet;
	asset?: APIResults.FleetAsset;
	components?: APIResults.AssetComponentList;
	worstrulcomponent?: AssemblyConfig.Component;
	worsthicomponent?: AssemblyConfig.Component;
	selectedview = "rtb";
	public brand = BrandVars;
	public hiHelp = "Below 0.75: Normal\n0.75 - 1.0: Warning\nAbove 1.0: Attention needed";
	public lastOperation: APIResults.Operation;
	public assetIcon?: string;

	constructor(private route: ActivatedRoute, private router: Router, private title: Title, public api: ApiService, private fleettracker: FleetTrackerService) { }

	async ngOnInit() {
		// TODO: fix up someday
		/* eslint-disable-next-line @typescript-eslint/no-this-alias */
		const me = this;

		let selected_asset_id: number;
		// A change in either the route parameter or the selected fleet must trigger a selection
		me.subscriptions.push(me.route.params.subscribe(params => {
			if (Number(params["assetid"]) !== selected_asset_id) {
				selected_asset_id = Number(params["assetid"]);
				me.fleettracker.SelectAsset(selected_asset_id);
			}
			if (params["view"]) {
				me.selectedview = params["view"];
			}
		}));
		me.subscriptions.push(me.fleettracker.currentFleet.subscribe(item => {
			me.fleettracker.SelectAsset(selected_asset_id);
			me.fleet = item;
		}));
		me.subscriptions.push(me.fleettracker.currentAsset.subscribe(async item => {
			me.asset = item;
			if (me.asset) {
				if (me.asset.is_fixed) {
					me.selectedview = "mech";
				}
				// Log access, don't wait
				this.api.LogAssetAccess(me.asset.asset_id).catch(() => console.error("Couldn't log access"));
				me.title.setTitle(BrandVars.appName + " - " + me.asset.asset_name);
				me.worstrulcomponent = undefined;
				me.worsthicomponent = undefined;
				const result = await me.api.GetComponents(me.asset.asset_id);
				if (result.alt_asset_icon) {
					me.assetIcon = result.alt_asset_icon;
				} else {
					me.assetIcon = "asset";
				}
				// Find worst RUL
				let worstrul: any = { state: { rul: Infinity } };
				let worsthi: any = { state: { filtered_hi: 0 } };
				const flattened = DvsUtilities.FlattenComponents(result);
				for (const comp of flattened) {
					if (comp.state && comp.state.rul && comp.state.rul > 0.5 && comp.state.rul < worstrul.state.rul) {
						worstrul = comp;
					}
					if (comp.state && comp.state.filtered_hi && comp.state.filtered_hi > worsthi.state.filtered_hi) {
						worsthi = comp;
					}
				}
				if (worstrul && worstrul.name) {
					me.worstrulcomponent = worstrul;
				}
				if (worsthi && worsthi.name) {
					me.worsthicomponent = worsthi;
				}
				me.components = result;
				if (!me.asset.is_fixed) {
					const operations = await this.api.GetOperations(this.asset.asset_id, 1);
					if (operations && operations.length === 1) {
						me.lastOperation = operations[0];
					}
				}
				// TODO: Error handling
			} else {
				me.components = undefined;
			}
		}));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	public selectView(viewName: string) {
		this.router.navigate([".", { view: viewName }], { relativeTo: this.route });
	}
}
